// src/components/parametrage/rapportsPointage/apiRapportsPointage.js
// Appels de l'onglet « Rapports » vers /api/parametres-pointage/rapports.
//
// Un client à part plutôt qu'une entrée de plus dans src/services/api.js : ce
// fichier commun porte déjà des modifications d'autres chantiers en attente de
// livraison, et l'onglet n'a que deux appels.

import { getAuthHeaders } from '../../../services/api';

const RACINE = '/api/parametres-pointage/rapports';

const requete = ({ du, au, population, employeId } = {}) => {
  const parametres = new URLSearchParams();
  if (du) parametres.set('du', du);
  if (au) parametres.set('au', au);
  if (population) parametres.set('population', population);
  if (employeId) parametres.set('employe_id', String(employeId));
  const texte = parametres.toString();
  return texte ? `?${texte}` : '';
};

const messageDErreur = (statut, donnees) => donnees?.message || (statut === 403
  ? "Vous n'avez pas la permission de générer le rapport de pointage."
  : 'Une erreur est survenue.');

export async function chargerSynthese(filtres) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}${requete(filtres)}`, { headers: getAuthHeaders() });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok || !donnees?.success) throw new Error(messageDErreur(reponse.status, donnees));
  return donnees.data;
}

/**
 * Le PDF, enregistré sous le nom que le serveur a choisi (il date le fichier
 * avec la période, calculée à l'heure de l'école).
 */
export async function telechargerPDF(filtres) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}/pdf${requete(filtres)}`, { headers: getAuthHeaders() });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  if (!reponse.ok) {
    let donnees = null;
    try { donnees = await reponse.json(); } catch { donnees = null; }
    throw new Error(messageDErreur(reponse.status, donnees));
  }
  const disposition = reponse.headers.get('Content-Disposition') || '';
  const nom = disposition.includes('filename=')
    ? disposition.split('filename=')[1].replace(/"/g, '').trim()
    : 'Rapport_pointage.pdf';
  const blob = await reponse.blob();
  const url = window.URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nom || 'Rapport_pointage.pdf';
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  window.URL.revokeObjectURL(url);
}
